
import { macroCondition, getGlobalConfig } from '@embroider/macros';


import implicitModules from "./-embroider-implicit-modules.js";


import * as amdModule0 from "./app.ts"
import * as amdModule1 from "./config.ts"
import * as amdModule2 from "./icons.ts"
import * as amdModule3 from "./registry.ts"
import * as amdModule4 from "./router.ts"
import * as amdModule5 from "./sample-data/index.ts"
import * as amdModule6 from "./services/-ensure-registered.js"
import * as amdModule7 from "./services/body-class.js"
import * as amdModule8 from "./services/resize-observer.js"
import * as amdModule9 from "./services/page-title.js"
import * as amdModule10 from "./services/kolay/api-docs.js"
import * as amdModule11 from "./services/kolay/compiler.js"
import * as amdModule12 from "./services/kolay/docs.js"
import * as amdModule13 from "./services/kolay/selected.js"
import * as amdModule14 from "./routes/api-docs.gts"
import * as amdModule15 from "./templates/application.gts"
import * as amdModule16 from "./routes/application.ts"
import * as amdModule17 from "./templates/index.gts"
import * as amdModule18 from "./templates/page.gts"

let exportFastbootModules = {};





export default Object.assign(
  {},
  implicitModules,
  {
"docs-app/app": amdModule0,
"docs-app/config": amdModule1,
"docs-app/icons": amdModule2,
"docs-app/registry": amdModule3,
"docs-app/router": amdModule4,
"docs-app/sample-data/index": amdModule5,
"docs-app/services/-ensure-registered": amdModule6,
"docs-app/services/body-class": amdModule7,
"docs-app/services/resize-observer": amdModule8,
"docs-app/services/page-title": amdModule9,
"docs-app/services/kolay/api-docs": amdModule10,
"docs-app/services/kolay/compiler": amdModule11,
"docs-app/services/kolay/docs": amdModule12,
"docs-app/services/kolay/selected": amdModule13,
"docs-app/routes/api-docs": amdModule14,
"docs-app/templates/application": amdModule15,
"docs-app/routes/application": amdModule16,
"docs-app/templates/index": amdModule17,
"docs-app/templates/page": amdModule18,
  },
  exportFastbootModules
);
